export class ListGoogleWorkspaceSharedDrivesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "search",
            "baseName": "search",
            "type": "string",
            "format": ""
        },
        {
            "name": "ids",
            "baseName": "ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "includedOrgUnitIds",
            "baseName": "includedOrgUnitIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "excludedOrgUnitIds",
            "baseName": "excludedOrgUnitIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGoogleWorkspaceSharedDrivesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
